var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Layout } from "@consta/uikit/Layout";
import { Text } from "@consta/uikit/Text";
import { Button } from "@consta/uikit/Button";
import styles from "./SignOut.module.scss";
var SignOut = function (_a) {
    var signoutHandler = _a.signoutHandler;
    return (_jsx(Layout, __assign({ className: styles.body, direction: "column" }, { children: _jsxs(Layout, __assign({ className: styles.content }, { children: [_jsx(Text, __assign({ size: "l", view: "primary" }, { children: "\u0425\u043E\u0442\u0438\u0442\u0435 \u0432\u044B\u0439\u0442\u0438 \u0438\u0437 \u0443\u0447\u0435\u0442\u043D\u043E\u0439 \u0437\u0430\u043F\u0438\u0441\u0438?" })), _jsx(Button, { className: styles.closeBtn, size: "m", view: "primary", label: "\u0412\u044B\u0439\u0442\u0438", width: "default", onClick: function () { return signoutHandler(); } })] })) })));
};
export default SignOut;
